import React from 'react'
import Button from '../Button'
import illustrationBodySectionM from '../../images/illustration-body-m.svg'
import illustrationBodySectionD from '../../images/illustration-body-d.svg'
import './bodySection.css'
import { AppModalContext } from "../AppModal/context";
import ContactForm from "../../components/ContactForm";
import { motion } from 'framer-motion';

let easing = [0.1575, 0.85, 0.42, 0.96];

const fadeInAnimation = {
  enter: { y: 0, opacity: 1, transition: { duration: 0.8, ease: easing } },
  exit: { y: 0, opacity: 0, transition: { duration: 0.8, ease: easing } }
}

const slideLeftAnimation = {
  enter: { x: 0, y: 0, opacity: 1, transition: { duration: 1.3, ease: easing } },
  exit: { x: -50, y: 0, opacity: 0, transition: { duration: 1.3, ease: easing } }
}

const BodySection = () => {
  const { handleModal } = React.useContext(AppModalContext);

  return (
    <motion.section initial="exit" animate="enter" exit="exit" className="section section--dark section-body-section">
      <motion.div variants={fadeInAnimation} className="section-body-section-content container-inner">
        <div className="heading">Noul transport în comun al bunurilor tale. Rezervă un loc.</div>
        <div className="py-2"></div>
        <ul className="points">
          <li className="point">Livrare rapidă urbană de până în 2 ore</li>
          <li className="point">Monitorizare în timp real pentru companie și client</li>
        </ul>
        <Button onClick={() => handleModal(<ContactForm formType="Înregistrează afacerea ta"/>)} type="secondary">Înregistrează afacerea ta</Button>
      </motion.div>
      <motion.img variants={slideLeftAnimation} className="illustration-m w-full" src={illustrationBodySectionM}/>
      <motion.img variants={slideLeftAnimation} className="illustration-d w-full" src={illustrationBodySectionD}/>
    </motion.section>
  )
}

export default BodySection;